import { render } from "./help-box.vue?vue&type=template&id=6b2126df&scoped=true"
import script from "./help-box.vue?vue&type=script&lang=js"
export * from "./help-box.vue?vue&type=script&lang=js"

import "./help-box.vue?vue&type=style&index=0&id=6b2126df&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2126df"]])

export default __exports__